// ANCHOR Base
import { Block } from 'baseui/block';
import { HeadingXSmall, LabelMedium } from 'baseui/typography';

// ANCHOR Models
import {
  useFormSubmissionQuestionItemRemark,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

export const LyonViewAnswerFormQuestionRemark = constant(() => {
  const remark = useFormSubmissionQuestionItemRemark();

  if (!remark) {
    return null;
  }

  return (
    <Block paddingTop="16px" paddingBottom="16px">
      <LabelMedium>
        Remark:
      </LabelMedium>
      <HeadingXSmall marginTop="4px" marginBottom={0}>
        {remark}
      </HeadingXSmall>
    </Block>
  );
});
